// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1NTF3","col":"Table_col__1JASV","fulfillmentStatus":"Table_fulfillmentStatus__wz3cg","emailCol":"Table_emailCol__1Z2v3"};